var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"droppable-field"},[_c('droppable',{class:[_vm.targetSelector],attrs:{"handle":".field-container","enabled":_vm.enabled},on:{"start":function($event){return _vm.$emit('start')},"end":function($event){return _vm.$emit('end')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }